import SquadSelection from "./SquadSelection";

export default function CompetitionSquadSelection() {
  return (
    <SquadSelection
      entityType="competition"
      title="Select Competition Squad"
      teamsEndpoint="/api/competitions/competitions/:id/teams/"
      squadEndpoint="/api/competitions/competition/:id/team/:tid/squad/"
    />
  );
}
